module.exports = __webpack_public_path__ + "static/media/argon-logo.31be2de4.png";